import { render, staticRenderFns } from "./input-bidang.vue?vue&type=template&id=4be30c4a&"
import script from "./input-bidang.vue?vue&type=script&lang=js&"
export * from "./input-bidang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports